import PrimaryButton from "components/buttons/primary-button";
import Typography from "components/typography";
import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  close: () => void;
  email: string;
  confirm: (otp: string) => void;
  resend: () => void;
}
const Verify = ({ close, email, confirm, resend }: IProps) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const OnVerify = async () => {
    setLoading(true);
    confirm(otp);
    setLoading(false);
  };

  useEffect(() => {
    if (otp.length === 6) {
      OnVerify();
    }
  }, [otp]);

  const OtpStyle = () => {
    let style = {
      width: "6.4rem",
      backgroundColor: Colors.grey700,
      marginRight: "2rem",
      height: "6.4rem",
      border: "1px solid #4E4E4E",
      borderRadius: "0.8rem",
      color: "white",
      fontSize: "3.2rem",
      fontWeight: "600"
    };

    if (window.innerWidth <= 768) {
      style = {
        ...style,
        width: "4.8rem",
        height: "4.8rem",
        fontSize: "2.4rem",
        marginRight: "0.8rem"
      };
    }

    return style;
  };

  return (
    <Container>
      <Header>
        <Typography color={Colors.white300} weight="semibold">
          Verify Your Email Address
        </Typography>
        <CancelIcon onClick={close}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            height="100%"
            viewBox="0 0 20 20"
            fill="none"
          >
            <path
              d="M15.8327 4.1665L4.16602 15.8332M4.16602 4.1665L15.8327 15.8332"
              stroke="#DDDDDD"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </CancelIcon>
      </Header>
      <Body>
        <Typography align="center" weight="semibold" mb="0.8">
          Please enter the 6 digit code we sent to {email}
        </Typography>
        <ChangeEmail onClick={close}>
          <Typography color={Colors.yellow400} size="s" mr="0.5">
            Change Emalil
          </Typography>
          <PenIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="100%"
              viewBox="0 0 13 12"
              fill="none"
            >
              <path
                d="M7.68005 2.03933L8.14345 1.57589C8.9113 0.808036 10.1562 0.808036 10.9241 1.57589C11.6919 2.34374 11.6919 3.58868 10.9241 4.35653L10.4606 4.81997M7.68005 2.03933C7.68005 2.03933 7.73795 3.02414 8.6069 3.89309C9.47585 4.76204 10.4606 4.81997 10.4606 4.81997M7.68005 2.03933L3.41941 6.29995C3.13083 6.58855 2.98654 6.7328 2.86245 6.8919C2.71606 7.0796 2.59057 7.28265 2.48817 7.4975C2.40136 7.67965 2.33684 7.87325 2.20778 8.2604L1.6609 9.90105M10.4606 4.81997L6.20005 9.0806C5.91145 9.36915 5.7672 9.51345 5.6081 9.63755C5.42041 9.78395 5.21734 9.90945 5.00249 10.0119C4.82035 10.0987 4.62676 10.1632 4.23959 10.2922L2.59896 10.8391M1.6609 9.90105L1.52722 10.3021C1.46371 10.4926 1.5133 10.7027 1.65531 10.8447C1.79733 10.9867 2.00739 11.0363 2.19792 10.9728L2.59896 10.8391M1.6609 9.90105L2.59896 10.8391"
                stroke="#FEB73D"
                stroke-width="0.875"
              />
            </svg>
          </PenIcon>
        </ChangeEmail>
        <OtpContainer>
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            inputStyle={OtpStyle()}
            renderInput={(props) => <input {...props} />}
          />
        </OtpContainer>
      </Body>
      <Footer>
        <PrimaryButton
          text="Verify"
          disabled={otp.length !== 6}
          loading={loading}
        />
        <ResendDiv>
          <Typography size="s" color={Colors.grey500}>
            Having Trouble receiving code?
          </Typography>
          <ResendBtn onClick={resend}>
            <Typography size="s" color={Colors.yellow400}>
              Resend Code
            </Typography>
          </ResendBtn>
        </ResendDiv>
      </Footer>
    </Container>
  );
};

export default Verify;

const Container = styled.div`
  border-radius: 0.8rem;
  width: 53.4rem;
  overflow: hidden;
  background-color: ${Colors.grey1000};
  @media only screen and (max-width: 769px) {
    width: 100%;
  }
`;

const Header = styled.div`
  width: 100%;
  padding: 1.6rem;
  background-color: ${Colors.grey700};
  border-bottom: 0.5px solid ${Colors.grey600};
  background: var(--Grey-700, #1e1e1e);
  display: flex;
  justify-content: space-between;
`;

const CancelIcon = styled.div`
  cursor: pointer;
  width: 2rem;
  height: 2rem;
`;

const Body = styled.div`
  background-color: ${Colors.grey1000};
  border-bottom: 0.5px solid ${Colors.grey600};
  padding: 3.9rem 2.5rem;
`;

const ChangeEmail = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const PenIcon = styled.div`
  width: 1.2rem;
  height: 1.2rem;
`;
const Footer = styled.div`
  width: 100%;
  padding: 2rem 2.5rem;
`;

const ResendDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 1.6rem;
`;

const ResendBtn = styled.div`
  cursor: pointer;
  margin-left: 0.5rem;
`;

const OtpContainer = styled.div`
  width: 100%;
  margin-top: 2.4rem;
  align-items: center;
  justify-content: center;
  font-family: "Switzer", sans-serif;
`;
